import React from "react";

const SignUpIcon = () => (
  <svg
    width="22"
    height="21"
    viewBox="0 0 22 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.9 5.14855L8.36 6.7041L11.22 9.59299H0V11.8152H11.22L8.36 14.7041L9.9 16.2597L15.4 10.7041L9.9 5.14855ZM19.8 18.4819H11V20.7041H19.8C21.01 20.7041 22 19.7041 22 18.4819V2.92632C22 1.7041 21.01 0.704102 19.8 0.704102H11V2.92632H19.8V18.4819Z"
      fill="#191919"
    />
  </svg>
);

export default SignUpIcon;
